export const URGENCY_LEVELS = {
  LOW: {
    label: "Scheduled Downtime",
    bgColor: "#DBEAFE",
    textColor: "#1E40AF",
    dotColor: "#3B82F6",
  },
  MEDIUM: {
    label: "Upcoming Downtime",
    bgColor: "#FEF3C7",
    textColor: "#92400E",
    dotColor: "#F59E0B",
  },
  HIGH: {
    label: "Downtime Soon",
    bgColor: "#FFEDD5",
    textColor: "#9A3412",
    dotColor: "#F97316",
  },
  CRITICAL: {
    label: "Starting Soon",
    bgColor: "#FEE2E2",
    textColor: "#991B1B",
    dotColor: "#EF4444",
  },
};

export const DISMISS_STORAGE_KEY = "maintenance_warning_dismissed";
export const IMMINENT_THRESHOLD_MIN = 30;
